export const getModalOpen = state => state.modal

export const getModalProps = state => state.modalProps
